import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { format } from 'date-fns';
import { ChartTooltip } from './ChartTooltip';

export const getFullChartConfig = () => {
  return {
    title: {
      text: '',
    },
    chart: {
      animation: false,
      type: 'line',
      backgroundColor: '#fff',
      spacingTop: 10,
    },
    legend: {
      x: 40,
      padding: 0,
      borderWidth: 0,
      itemDistance: 20,
      labelFormatter() {
        const { color } = this.userOptions;
        this.legendItem.line.attr({
          d: ['M', 0, 5, 'H', 10, 'V', 15, 'H', 0, 'L', 0, 5],
          fill: color,
        });
        return this.name;
      },
    },
    plotOptions: {
      series: {
        marker: {
          enabled: false,
          states: {
            hover: {
              enabled: true,
            },
          },
          symbol: 'circle',
          radius: 2,
        },
      },
      line: {
        states: {
          hover: {
            marker: {
              lineWidthPlus: 0,
              radius: 2,
            },
            halo: {
              size: 0,
            },
          },
        },
      },
    },
    responsive: {
      rules: [{
        condition: {
          maxWidth: 300,
        },
        chartOptions: {
          chart: {
            spacingRight: 0,
          },
          legend: {
            padding: 0,
            margin: -20,
            align: 'center',
          },
          navigator: {
            enabled: false,
          },
          yAxis: {
            labels: {
              enabled: false,
            },
          },
        },
      }],
    },
    time: {
      useUTC: true,
    },
    credits: {
      enabled: false,
    },
    tooltip: getTooltipConfig(),
    xAxis: getDataFormatterXaxis(),
    yAxis: getDataFormatterYaxis(),
  };
};

export function getDataFormatterXaxis() {
  return {
    type: 'datetime',
    gridLineColor: '#f3f3f3',
    lineColor: '#c0c0c0',
    labels: {
      startOnTick: true,
      min: null,
      style: {
        color: '#616161',
      },
      formatter(v) {
        return format(new Date(v.value), 'MMM yyyy');
      },
    },
  };
}

export function getDataFormatterYaxis() {
  return {
    endOnTick: true,
    showFirstLabel: false,
    showLastLabel: false,
    gridLineWidth: 1,
    gridLineColor: '#f3f3f3',
    lineColor: '#c0c0c0',
    lineWidth: 1,
    tickAmount: 10,
    labels: {
      enabled: true,
      style: {
        color: '#616161',
        fontSize: '9px',
        width: '175px',
      },
      formatter() {
        return this.value;
      },
    },
    title: {
      text: 'Price $',
      align: 'high',
      rotation: 0,
      offset: 0,
      position3d: 'flap',
      y: 5,
      x: -11,
    },
  };
}

export function getTooltipConfig() {
  return {
    outside: true,
    split: false,
    enabled: true,
    useHTML: true,
    followTouchMove: false,
    valueDecimals: 2,
    padding: 0,
    backgroundColor: '#fff',
    formatter() {
      return ReactDOMServer.renderToString(
        <ChartTooltip date={ this.x } value={ this.y } />,
      );
    },
  };
}
